/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import { StyleSheet } from 'react-native-unistyles';
import { pd } from '@airasia-phoenix/react-native/utils';

export const styles = StyleSheet.create({
  container: {
    position: 'absolute',
    marginTop: {
      xs: 0,
      md: 5,
    },
  },

  overlay: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },

  backdrop: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    padding: pd.ref.space.spacing60.px,
  },
  card: {
    borderRadius: pd.ref.space.spacing30.px,
    overflow: 'hidden',
    elevation: 6,
  },
});
